import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { IMaskinlag } from "~app/features/planera/model/IMaskinLag";
import { IMaskinLagBase } from "~app/features/planera/model/IMaskinLagBase";
import { ApiClientService } from "../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderSearchService {
    private readonly apiClient = inject(ApiClientService);

    getAnvandareTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        input = input.trim();
        return this.apiClient.post<any, ITypeAheadResult[]>(
            "typeahead/anvandare",
            {
                query: input,
                addUserUserNameToName: true
            },
            false,
            null,
            ApiClientService.JsonHeader);
    }

    getMinaMaskinlag(): Observable<IMaskinlag[]> {
        return this.apiClient.get("Planera/GetMinaMaskinlag", true);
    }

    getAllMaskinlag(): Observable<IMaskinLagBase[]> {
        return this.apiClient.get(`Planera/GetAllMaskinlag`, true);
    }

    private getHeader(): HttpHeaders {
        const headers = new HttpHeaders();
        return headers.append("content-type", "application/json");
    }
}
